import { Component, OnInit } from '@angular/core';
import { NavMenuComponent } from '../components/navmenu/navmenu.component';
import { MenuItem } from '../components/wolfie-context-menu/menu-item';

declare var document: any;

@Component( {
  selector: 'mobile-nav-menu',
  template: require('./mobile-nav-menu.component.html'),
  styles: [ require('./mobile-nav-menu.component.css') ]
} )
export class MobileNavMenuComponent extends NavMenuComponent {

  get fullscreen (): boolean {
    return this._fullscreen;//document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen || false;
  }

  set fullscreen ( value ) {
    if ( toggleFullscreen( value ) )
      this._fullscreen = value;
  }

  _fullscreen = false;

  get navMenu () {
    if ( this.dataService.LiveAccount ) {
      return [
        new MenuItem( 'Manage Accounts', () => this.showDemoUsersModal() ),
        new MenuItem( 'Profile', () => this.showUserProfileModal() ),
        new MenuItem(), //separator
        new MenuItem( 'Sign In - Live Trading', () => this.showLoginModal() ),
        new MenuItem( 'Open Live Account' ),
        new MenuItem(), //separator
        this.createToggleMenuItem( 'Show period', () => this.changeGlobalGridMode(), () => this.showGrid ),
        this.createToggleMenuItem( 'Show current rate', () => this.toggleLastPriceIndicator(), () => this.showLastPriceIndicator ),
        this.createToggleMenuItem( 'Show trade lines', () => this.toggleTradeLines(), () => this.showTradeLines ),
        this.createToggleMenuItem( 'Show indicator lines', () => this.toggleIndicatorLines(), () => this.showIndicatorLines ),
        this.createToggleMenuItem( 'Fullscreen', () => this.fullscreen = !this.fullscreen, () => this.fullscreen ),
        new MenuItem( 'Logout', () => this.logoutAction() ),
      ];
    }
    else {
      return [
        new MenuItem( 'Manage Accounts', () => this.showDemoUsersModal() ),
        new MenuItem( 'Profile', () => this.showUserProfileModal() ),
        new MenuItem(), //separator
        this.createToggleMenuItem( 'Show period', () => this.changeGlobalGridMode(), () => this.showGrid ),
        this.createToggleMenuItem( 'Show current rate', () => this.toggleLastPriceIndicator(), () => this.showLastPriceIndicator ),
        this.createToggleMenuItem( 'Show trade lines', () => this.toggleTradeLines(), () => this.showTradeLines ),
        this.createToggleMenuItem( 'Show indicator lines', () => this.toggleIndicatorLines(), () => this.showIndicatorLines ),
        this.createToggleMenuItem( 'Fullscreen', () => this.fullscreen = !this.fullscreen, () => this.fullscreen ),
        new MenuItem( 'Logout', () => this.logoutAction() ),
      ];
    }
  }

  openNavMenu () {
    this._fullscreen = ( document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen || false );
    this.contextMenuService.show( { x: 0, y: 0 }, this.navMenu, undefined, 23 );
  }

  logoutAction () {
    super.logoutAction();
    location.reload();
  }

  setMenuItemChecked ( menuItem: MenuItem, checked = false ) {
    menuItem.iconClass = `ac ${ checked ? "ac-check-thin" : "" }`;
  }

  createToggleMenuItem ( name: string, callback: () => void, state: () => boolean ) {
    const menuItem = new MenuItem( name, () => {
      callback();
      this.setMenuItemChecked( menuItem, state() );
    } );
    menuItem.iconNgStyle = { 'padding-top': '2px', 'border': '1px solid' };
    this.setMenuItemChecked( menuItem, state() );
    return menuItem;
  }

}

export function toggleFullscreen ( toggle: boolean, elem?: any ) {
  if ( ( document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen || false ) == toggle )
    return false;
  elem = elem || document.documentElement;
  if ( toggle ) {
    if ( elem.requestFullscreen ) {
      elem.requestFullscreen();
    } else if ( elem.msRequestFullscreen ) {
      elem.msRequestFullscreen();
    } else if ( elem.mozRequestFullScreen ) {
      elem.mozRequestFullScreen();
    } else if ( elem.webkitRequestFullscreen ) {
      elem.webkitRequestFullscreen();
    }
  } else {
    if ( document.exitFullscreen ) {
      document.exitFullscreen();
    } else if ( document.msExitFullscreen ) {
      document.msExitFullscreen();
    } else if ( document.mozCancelFullScreen ) {
      document.mozCancelFullScreen();
    } else if ( document.webkitExitFullscreen ) {
      document.webkitExitFullscreen();
    }
  }
  return true;
}
